import actions from './actions'

const initState = {
    events: [],
    currentEvent: null,
    listCurrentEvent: null,
    isLoading: false,
    visibleEditModal: false,
    visibleRemoveModal: false,
    visibleCreateModal: false,
    idRemove: 0,
    totalEvent: 0,
    currentOwner: {},
}

const eventReducer = (state = initState, action) => {
    switch (action.type) {
        case actions.type.SEARCH_EVENT_BY_TEXT_DONE:
            return {
                ...state,
                ...{
                    events: action.payload.data,
                    totalEvent: action.payload.total,
                },
            }
        case actions.type.GET_OWNER_EVENT_INFO_DONE:
            return {
                ...state,
                ...{
                    currentOwner: action.payload.data,
                },
            }

        case actions.type.GET_LIST_EVENT:
            return {
                ...state,
                ...{
                    isLoading: true,
                },
            }

        case actions.type.GET_LIST_EVENT_DONE:
            return {
                ...state,
                ...{
                    isLoading: false,
                    events: action.payload.data,
                    totalEvent: action.payload.total,
                },
            }

        case actions.type.GET_EVENT_BY_ID:
            return {
                ...state,
                ...{
                    isLoading: true,
                },
            }

        case actions.type.GET_EVENT_BY_ID_DONE:
            console.log('data reducer', action.payload.data)
            return {
                ...state,
                ...{
                    isLoading: false,
                    currentEvent: action.payload.data,
                },
            }
        case actions.type.VISIBLE_MODAL_EDIT:
            return {
                ...state,
                ...{
                    visibleEditModal: action.payload.isVisible,
                },
            }
        case actions.type.VISIBLE_MODAL_REMOVE:
            return {
                ...state,
                ...{
                    visibleRemoveModal: action.payload.isVisible,
                    idRemove: action.payload.eid,
                },
            }
        case actions.type.VISIBLE_MODAL_CREATE:
            return {
                ...state,
                ...{
                    visibleCreateModal: action.payload.isVisible,
                },
            }
        case actions.type.GET_LIST_EVENT_QUERY_BY_ID_DONE:
            return {
                ...state,
                ...{
                    listCurrentEvent: action.payload.data,
                },
            }
        default:
            return state
    }
}

export default eventReducer
